import { ChevronDown, ChevronUp } from 'baseui/icon'
import { PulseToggleButton } from './styled-components'

interface PulseToggleIconProps {
  $expanded?: boolean
}

const PulseToggleIcon = ({ $expanded }: PulseToggleIconProps) => (
  <PulseToggleButton aria-hidden='true'>
    {$expanded ? <ChevronUp size={18} color='currentColor' /> : <ChevronDown size={18} color='currentColor' />}
  </PulseToggleButton>
)

export default PulseToggleIcon
